






























































































import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import RepeatableInputGroup from '@/components/common/RepeatableInputGroup.vue';

@Component({
  components: {
    RepeatableInputGroup,
  },
  inheritAttrs: false,
})
export default class WorkCollection extends Vue {
  @Prop({ default: true, type: Boolean })
  hasAddMoreButton!: boolean;

  @Prop({ default: true, type: Boolean })
  hasDeleteWorkButton!: boolean;

  @Prop({ default: true, type: Boolean })
  hasRemoveWorkRowButton!: boolean;

  @Prop()
  title!: string;

  @Prop({ default: '' })
  icon!: string;

  @Prop({ default: '' })
  fieldCollectionName!: string;

  @Prop({ default: () => ({}) })
  propagatedValue!: any;

  @Prop({ default: () => null })
  validations!: any;

  @Prop({ default: () => null })
  fieldCollectionNormalizer!: any;

  @Prop({ default: () => null })
  model!: any;

  @Prop({ default: () => false })
  workDisabled!: any;

  @Prop({ default: () => false })
  returnWorkDisabled!: any;

  rows = [
    'workType',
    'booleanFields',
    'operations',
  ]

  get workArray() {
    return this?.propagatedValue;
  }

  get workValidations() {
    return this?.validations;
  }

  onDeleteWork() {
    this.$emit('delete-work');
  }

  onInputGroup(value: any) {
    if (this.fieldCollectionNormalizer) {
      value = this.fieldCollectionNormalizer
        .normalize({
          fieldName: this.fieldCollectionName,
          value,
        });
    }
    this.$emit('input', value);
  }
}
